module.exports = __webpack_public_path__ + "static/img/desicionB.7c98a016.png";